import config from "../config";

import DashboardLayout from "../components/Dashboard/Layout/DashboardLayout.vue";
// GeneralViews
import NotFound from "../components/GeneralViews/NotFoundPage.vue";
// Dashboard pages
const Overview = () =>
  import(/* webpackChunkName: "widgets" */ "src/components/Dashboard/Views/Dashboard/Overview.vue");
const Widgets = () =>
  import(/* webpackChunkName: "widgets" */ "src/components/Dashboard/Views/Dashboard/Widgets.vue");

// Pages
// Users
import UserEdit from "src/components/Dashboard/Views/Pages/Users/UserEdit.vue";
// Accounts
import SelectAccount from "src/components/Dashboard/Views/Pages/AccountSelect.vue";
import AccountEdit from "src/components/Dashboard/Views/Pages/Accounts/AccountEdit.vue";

// Drivers
import DriversList from "src/components/Dashboard/Views/Pages/Drivers/DriversList.vue";
import DriverPage from "src/components/Dashboard/Views/Pages/Drivers/DriverPage.vue";

// Sales
import SalesList from "src/components/Dashboard/Views/Pages/Sales/SalesList.vue";
import SalePage from "src/components/Dashboard/Views/Pages/Sales/SalePage.vue";

// Terminals
import TerminalsList from "src/components/Dashboard/Views/Pages/Terminals/TerminalsList.vue";
import TerminalPage from "src/components/Dashboard/Views/Pages/Terminals/TerminalPage.vue";

import Login from "src/components/Dashboard/Views/Pages/Login.vue";
import Register from "src/components/Dashboard/Views/Pages/Register.vue";

import Lock from "src/components/Dashboard/Views/Pages/Lock.vue";

// Components pages
import Buttons from "src/components/Dashboard/Views/Components/Buttons.vue";
import GridSystem from "src/components/Dashboard/Views/Components/GridSystem.vue";
import Panels from "src/components/Dashboard/Views/Components/Panels.vue";
import SweetAlert from "src/components/Dashboard/Views/Components/SweetAlert.vue";
import Notifications from "src/components/Dashboard/Views/Components/Notifications.vue";
import Icons from "src/components/Dashboard/Views/Components/Icons.vue";
import Typography from "src/components/Dashboard/Views/Components/Typography.vue";

// Forms pages
const RegularForms = () =>
  import(/* webpackChunkName: "forms" */ "src/components/Dashboard/Views/Forms/RegularForms.vue");
const ExtendedForms = () =>
  import(/* webpackChunkName: "forms" */ "src/components/Dashboard/Views/Forms/ExtendedForms.vue");
const ValidationForms = () =>
  import(/* webpackChunkName: "forms" */ "src/components/Dashboard/Views/Forms/ValidationForms.vue");
const Wizard = () =>
  import(/* webpackChunkName: "forms" */ "src/components/Dashboard/Views/Forms/Wizard.vue");

// TableList pages
const RegularTables = () =>
  import(/* webpackChunkName: "tables" */ "src/components/Dashboard/Views/Tables/RegularTables.vue");
const ExtendedTables = () =>
  import(/* webpackChunkName: "tables" */ "src/components/Dashboard/Views/Tables/ExtendedTables.vue");
const PaginatedTables = () =>
  import(/* webpackChunkName: "tables" */ "src/components/Dashboard/Views/Tables/PaginatedTables.vue");
// Maps pages
const GoogleMaps = () =>
  import(/* webpackChunkName: "maps" */ "src/components/Dashboard/Views/Maps/GoogleMaps.vue");
const FullScreenMap = () =>
  import(/* webpackChunkName: "maps" */ "src/components/Dashboard/Views/Maps/FullScreenMap.vue");
const VectorMaps = () =>
  import(/* webpackChunkName: "maps" */ "src/components/Dashboard/Views/Maps/VectorMapsPage.vue");

// Calendar
import Calendar from "src/components/Dashboard/Views/Calendar/CalendarRoute.vue";
// Charts
const Charts = () =>
  import(/* webpackChunkName: "widgets" */ "src/components/Dashboard/Views/Charts.vue");

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      component: Buttons
    },
    {
      path: "grid-system",
      name: "Grid System",
      component: GridSystem
    },
    {
      path: "panels",
      name: "Panels",
      component: Panels
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      component: SweetAlert
    },
    {
      path: "notifications",
      name: "Notifications",
      component: Notifications
    },
    {
      path: "icons",
      name: "Icons",
      component: Icons
    },
    {
      path: "typography",
      name: "Typography",
      component: Typography
    }
  ]
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      component: RegularForms
    },
    {
      path: "extended",
      name: "Extended Forms",
      component: ExtendedForms
    },
    {
      path: "validation",
      name: "Validation Forms",
      component: ValidationForms
    },
    {
      path: "wizard",
      name: "Wizard",
      component: Wizard
    }
  ]
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  children: [
    {
      path: "regular",
      name: "Regular Tables",
      component: RegularTables
    },
    {
      path: "extended",
      name: "Extended Tables",
      component: ExtendedTables
    },
    {
      path: "paginated",
      name: "Paginated Tables",
      component: PaginatedTables
    }
  ]
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      component: GoogleMaps
    },
    {
      path: "full-screen",
      name: "Full Screen Map",
      component: FullScreenMap
    },
    {
      path: "vector-map",
      name: "Vector Map",
      component: VectorMaps
    }
  ]
};

let loginPage = {
  path: "/login",
  name: "Login",
  component: Login,
  meta: {
    auth: false
  }
};

let registerPage = {
  path: "/register",
  name: "Register",
  component: Register,
  meta: {
    auth: false
  }
};

let accountSelectPage = {
  path: "/select-account",
  name: "Select account",
  component: SelectAccount,
  meta: {
    auth: true
  }
};

let userMenu = {
  path: "/user",
  component: DashboardLayout,
  redirect: "/user/edit",
  meta: {
    auth: true
  },
  beforeEnter: checkForSelectedAccount,
  children: [
    {
      path: "edit",
      name: "Edit user",
      component: UserEdit
    }
  ]
};

let lockPage = {
  path: "/lock",
  name: "Lock",
  component: Lock
};

function checkForSelectedAccount(to, from, next) {
  // check whether user has an account set to localstorage
  const account = JSON.parse(
    localStorage.getItem(`${config.namespace}__account`)
  );
  if (account && account.value) {
    return next();
  } else {
    return next("/select-account");
  }
}

let accountsMenu = {
  path: "/account",
  component: DashboardLayout,
  redirect: "/account/dashboard",
  meta: {
    auth: true
  },
  beforeEnter: checkForSelectedAccount,
  children: [
    {
      path: "dashboard",
      name: "Account Dashboard",
      component: Overview
    },
    {
      path: "edit",
      name: "Edit Account",
      component: AccountEdit
    },
    {
      path: "transactions",
      name: "Transactions",
      component: FullScreenMap
    },
    {
      path: "drivers",
      name: "DriversList",
      component: DriversList
    },
    {
      path: "drivers/:driverId",
      component: DriverPage,
      props: true,
      name: "Driver"
    },
    {
      path: "sales",
      name: "SalesList",
      component: SalesList
    },
    {
      path: "sales/:saleId",
      component: SalePage,
      props: true,
      name: "Sale"
    },
    {
      path: "terminals",
      name: "TerminalsList",
      component: TerminalsList
    },
    {
      path: "terminals/:terminalId",
      component: TerminalPage,
      props: true,
      name: "Terminal"
    }
  ]
};

const routes = [
  loginPage,
  registerPage,
  accountSelectPage,
  accountsMenu,
  userMenu,
  {
    path: "/",
    redirect: "/account"
  },
  tablesMenu, // TODO: REMOVE THIS
  { path: "*", component: NotFound }
];

// const routes = [
//   {
//     path: "/",
//     component: DashboardLayout,
//     redirect: "/admin/overview",
//     meta: {
//       auth: true
//     },
//     children: [
//       {
//         path: "calendar",
//         name: "Calendar",
//         component: Calendar
//       },
//       {
//         path: "charts",
//         name: "Charts",
//         component: Charts
//       }
//     ]
//   },
//   componentsMenu,
//   formsMenu,
//   tablesMenu,
//   mapsMenu,
//   pagesMenu,
//   loginPage,
//   registerPage,
//   lockPage,
//   {
//     path: "/admin",
//     component: DashboardLayout,
//     redirect: "/admin/overview",
//     meta: {
//       auth: true
//     },
//     children: [
//       {
//         path: "overview",
//         name: "Overview",
//         component: Overview
//       },
//       {
//         path: "widgets",
//         name: "Widgets",
//         component: Widgets
//       }
//     ]
//   },
//   { path: "*", component: NotFound }
// ];

export default routes;
